export const GLOBALS = {
  NAME: 'PROD',
  PRODUCTION: true,
  API: {
    BASE_URL: 'https://balloons-api.digitalemenschen.app',
    BALLOONS: '/balloons',
  },
  TRANSLATION_PATH: './assets/i18n/',
  GMAP: {
    API_KEY: 'AIzaSyBXzoghdJTrpuydWgN5K2wW1LYwM-eI94M',
    INITIAL_CENTER: { lat: 47.462520, lng: 7.813823 },  // Sissach: 47.462520, 7.813823
    INITIAL_ZOOM: 15,
    MARKER_SIZE: 40,
    MARKER_SIZE_TV: 80,
    MAP_ID: 'ef264cd903521b34',
  },
  DEFAULT_BALLOON_ICON: 'assets/icons/balloon-type-0.svg',
  REFRESH_MAP_INTERVAL: 30000,
  SCREEN_RANGLIST_BALLOONS_COUNT: 10,
};
